/* eslint-disable no-restricted-syntax */
export function sortByKey(array: any[], key: string, asc = true) {
  return array.sort((e1, e2) => {
    const x = e1[key];
    const y = e2[key];
    if (asc) {
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    }
    return ((x < y) ? 1 : ((x > y) ? -1 : 0));
  });
}

export function splitInHalf(array: any[], distributeLast = false) {
  let firstHalf = [];
  let secondHalf = [];
  try {
    if (distributeLast) {
      const i1 = Math.floor(array.length / 2);
      const i2 = Math.ceil(array.length / 2);
      firstHalf = array.splice(0, i1);
      secondHalf = array.splice(-i2);
    } else {
      const halfIndex = Math.ceil(array.length / 2);
      firstHalf = array.splice(0, halfIndex);
      secondHalf = array.splice(-halfIndex);
    }
  } catch (err) {
    throw new Error('Failed to split array', err);
  }

  return [firstHalf, secondHalf];
}

export function areArraysEqualSets(a1: any[], a2: any[]) {
  const superSet = {};
  for (const i of a1) {
    const e = i + typeof i;
    superSet[e] = 1;
  }

  for (const i of a2) {
    const e = i + typeof i;
    if (!superSet[e]) {
      return false;
    }
    superSet[e] = 2;
  }

  for (const e in superSet) {
    if (superSet[e] === 1) {
      return false;
    }
  }

  return true;
}

export function randomFromArray(array: any[]) {
  return array[Math.floor(Math.random() * array.length)];
}

export function removeElement(arr: any[], value: any) {
  if (!arr || !Array.isArray(arr)) return null;
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export function arraysEqual(arr1: any[], arr2: any[]) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) return false;
  return arr1.every((obj1, index) => JSON.stringify(obj1) === JSON.stringify(arr2[index]));
}

export function isArrayEmpty(arr: any, strict = false) {
  if (strict) {
    return !Array.isArray(arr) || !arr.length;
  }
  return !arr?.length;
}

export function isArray(arr: any) {
  return Array.isArray(arr);
}

export function splitInChunks<T>(array: T[] = [], size: number = 8): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export function createArray(count: number, fill = 0) {
  return new Array(count).fill(fill);
}

export function isInArray(arr, el) {
  return arr.indexOf(el) > -1;
}
